import type { DiamInvitation } from '../../diamApi';
import { EMPTY_TEAM_NAME } from '../RoleDetails/constants';
import { Invitation, InvitationStatus } from './types';

const INVITATION_STATUS_BY_API: Record<
  DiamInvitation['status'],
  InvitationStatus
> = {
  PENDING: 'pending',
  ACCEPTED: 'accepted',
  REVOKED: 'revoked',
  EXPIRED: 'expired',
};

function mapExpiresAt(expiresAt: string | undefined): string {
  return expiresAt?.slice(0, 10) ?? '';
}

export function mapApiInvitation(invitation: DiamInvitation): Invitation {
  const roleIds = (invitation.roles ?? [])
    .map(role => role.roleId)
    .filter(Boolean);

  const teamId = invitation.team?.id ?? invitation.teamId ?? '';
  const teamName = invitation.team?.name?.trim() || EMPTY_TEAM_NAME;

  return {
    id: invitation.id,
    email: invitation.email,
    teamId,
    teamName,
    teams: teamName !== EMPTY_TEAM_NAME ? [teamName] : [],
    roles: (invitation.roles ?? [])
      .map(role => role.name)
      .filter(name => Boolean(name)),
    roleIds,
    applications: [],
    status: INVITATION_STATUS_BY_API[invitation.status] ?? 'pending',
    expiresAt: mapExpiresAt(invitation.expiresAt),
    link: '',
  };
}
